export interface Settings {
  stage: string;
  apiEndpoint: string;
  agentEndpoint: string;
  discoveryAgentEnabled?: boolean;
}

let cachedSettings: Settings | null = null;

export async function loadSettings(): Promise<Settings> {
  if (cachedSettings) {
    return cachedSettings;
  }

  const response = await fetch('/settings.json');
  if (!response.ok) {
    throw new Error('Failed to load settings');
  }

  cachedSettings = await response.json();
  return cachedSettings!;
}

export function getSettings(): Settings | null {
  return cachedSettings;
}
